<template>
    <modal id="delete-note-modal">
        <template slot="title">Delete Note</template>

        <template slot="body">
            <p>Do you want to delete the folloing note?</p>
            <div class="font-italic text-muted">{{ note.note }}</div>
        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal('delete-note-modal')">
                Cancel
            </button>
            <button class="btn btn-danger" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Delete</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Processing...</span>
            </button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            note: {
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                form: new Form({})
            }
        },

        methods: {
            save() {
                axios.delete(`${this.url}/${this.note.id}`).then(response => {
                    this.closeModal('delete-note-modal')
                    Toast.success('Your note was deleted successfully!')
                    this.$emit('deleted', this.note);
                }).catch(errors => {
                    Toast.error(errors.first());
                })
            }
        }
    }
</script>
